import React from "react";

/**
 * Eyebrow + heading + optional kicker block used across pages.
 */
export const SectionHeading = ({
    eyebrow,
    title,
    kicker,
    align = "left",
    invert = false,
    className = "",
}) => {
    const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
    const titleColor = invert ? "text-white" : "text-indigo_brand";
    const kickerColor = invert ? "text-white/75" : "text-[#4A5568]";
    return (
        <div className={`max-w-3xl ${alignClass} ${className}`}>
            {eyebrow && <p className="ih-eyebrow">{eyebrow}</p>}
            <h2
                className={`mt-3 font-montserrat font-bold ${titleColor} text-3xl sm:text-4xl lg:text-[2.65rem] leading-[1.1] tracking-tight`}
            >
                {title}
            </h2>
            {kicker && (
                <p
                    className={`mt-5 font-opensans text-base sm:text-lg leading-relaxed ${kickerColor}`}
                >
                    {kicker}
                </p>
            )}
        </div>
    );
};

export default SectionHeading;
